/**
 * Classe responsável pelas ações do grid para o servicetime updates
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 08/08/2013
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};
Greenmile.ServiceTimeUpdates.Grid = Greenmile.ServiceTimeUpdates.Grid || {};

Greenmile.ServiceTimeUpdates.Grid.Location = function () {

    Greenmile.ServiceTimeUpdates.Grid.apply(this, arguments);

    //This entity is only ServiceTimeUpdates, because the first version is justo for
    //location.
    this.entity = 'ServiceTimeUpdates';
    this.entityToRequest = "ServiceTimeUpdLocation";
    this.collection = App.Collections.ServiceTimeUpdateLocations;

    this.getParams = function() {
        return {
            url : this.entityToRequest,
            data: {serviceTimeUpdLocations: [] },
            objName: 'serviceTimeUpdLocations'
        };
    };

};
